import React from 'react';
import { Button, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import QuestionList from './QuestionList';
// import fakeData from 'modules/OlympicSGKModule/fakeData';
import Container from 'components/Containers/Container';

import fakeData from 'modules/OlympicSGKModule/ClassExam/classExam04Data';
import SuccessPage from '../SuccessPage';
import randomData from './ramdonData';

import Matching from 'modules/OlympicSGKModule/components/Matching';
import OneChoice from 'modules/OlympicSGKModule/components/OneChoice';
import SelectWord from 'modules/OlympicSGKModule/components/SelectWord';
import Underlined from 'modules/OlympicSGKModule/components/Underlined';
import Unscramble from 'modules/OlympicSGKModule/components/Unscramble';
import Conjugation from 'modules/OlympicSGKModule/components/Conjugation';
import FillInTheBlank from 'modules/OlympicSGKModule/components/FillInTheBlank';
import MatchingTwoColumn from 'modules/OlympicSGKModule/components/MatchingTwoColumn';
import FillWordInTheBlank from 'modules/OlympicSGKModule/components/FillWordInTheBlank';
import FillLetterInTheBlank from 'modules/OlympicSGKModule/components/FillLetterInTheBlank';
import SelectWordsInSentence from 'modules/OlympicSGKModule/components/SelectWordsInSentence';
import Countdown from 'antd/lib/statistic/Countdown';
import Axios from 'axios';

const types = {
  Matching,
  OneChoice,
  SelectWord,
  Underlined,
  Unscramble,
  Conjugation,
  FillInTheBlank,
  MatchingTwoColumn,
  FillWordInTheBlank,
  FillLetterInTheBlank,
  SelectWordsInSentence,
};

const ClassExam = () => {
  const [dataFromApi, setDataFromApi] = React.useState([]);
  const [data, setData] = React.useState(randomData[0]);
  const [userDataList, setUserDataList] = React.useState([]);
  // State chỉ dùng để hiển thị màu của button được chọn
  const [selectedButton, setSelectedButton] = React.useState(0);
  const [complete, setExamComplete] = React.useState(false);
  const [countDown, setCountDown] = React.useState(0);
  const onSubmit = React.useCallback(
    (answers) => {
      const data = userDataList.filter((x) => x.id !== answers.id);
      data.push(answers);
      setUserDataList(data);

      // Lưu đáp án người dùng lên server
      localStorage.setItem('OLYMPIC_SGK_USER_DATA', JSON.stringify(data));

      //Bài tiếp theo
      const currentIndex = dataFromApi.findIndex((x) => x.id === answers.id);
      if (currentIndex === dataFromApi.length - 1) {
        return;
      }
      const nextQuestion = dataFromApi[currentIndex + 1];
      setData(nextQuestion);
      setSelectedButton(currentIndex + 1);
    },
    [dataFromApi, userDataList],
  );

  //chọn câu hỏi
  const onSelectQuestion = React.useCallback(
    (selectedItem) => {
      const question = dataFromApi[selectedItem - 1];
      setData(question);
      setSelectedButton(selectedItem - 1);
    },
    [dataFromApi],
  );

  const onFinish = React.useCallback((isComplete) => {
    setExamComplete(isComplete);
    localStorage.removeItem('OLYMPIC_SGK_USER_DATA');
    localStorage.removeItem('COUNT_DOWN');
  }, []);

  React.useEffect(() => {
    // Kết quả bài làm cũ
    const storageData = JSON.parse(localStorage.getItem('OLYMPIC_SGK_USER_DATA'));
    setUserDataList(storageData ?? []);
    //kiểm tra đếm ngược
    const countdown = localStorage.getItem('COUNT_DOWN');
    setCountDown(countdown ? parseInt(countdown) : Date.now() + 1000 * 60 * 30);
    if (!countdown) {
      const deadline = Date.now() + 1000 * 60 * 30;
      localStorage.setItem('COUNT_DOWN', deadline);
    }
    // Đề
    const cachedData = JSON.parse(localStorage.getItem('OLYMPIC_SGK_DATA'));
    if (cachedData && randomData === cachedData) {
      setDataFromApi(cachedData);
    } else {
      // Lấy dữ liệu từ api
      setDataFromApi(randomData);
      localStorage.setItem('OLYMPIC_SGK_DATA', JSON.stringify(randomData));
    }
  }, []);

  const QuestionComponent = types[data?.type];
  const userData = data && userDataList.find((x) => x.id === data.id)?.answers;

  const result = (array_data) => {
    const res = array_data.reduce((total, item) => (item.isCorrect ? total + 1 : total), 0);
    return `${res}/${array_data.length}`;
  };

  return (
    <div name='Olympic English' parentName='Sách số' className='p-4'>
      <Row>
        <Col lg={10} md={9}>
          {!complete && data ? <QuestionComponent data={data} onSubmit={onSubmit} userData={userData ?? []} /> : <SuccessPage />}
        </Col>
        <Col lg={2} md={3}>
          <Card>
            <CardBody>
              <div style={{ textAlign: 'center' }}>
                <Countdown title='Thời gian làm bài' value={countDown} onFinish={''} />
              </div>
              <div>
                <QuestionList data={dataFromApi} onSelect={onSelectQuestion} selected={selectedButton} userData={userDataList} />
                <Button onClick={() => onFinish(true)} color='default' block>
                  HOÀN THÀNH
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ClassExam;
